
import { lazy } from 'react';

export const routes = [
  {
    path: "/paymethod",
    exact: true,
    component: lazy(() => import("./components/Paymethod")),
    name: "Payment Methods"
  }
];

